import { WebsitePageLocale } from 'src/shared/types/website-page-interface'

export const WEBSITE_PAGE_URL_PLACEHOLDER = '%WEBSITE_PAGE_URL_ %'

export const getWebsitePageReplacement = (pageId: number) => {
  return WEBSITE_PAGE_URL_PLACEHOLDER.replace(' ', String(pageId))
}

export const isWebsitePageUrlPlaceholder = (placeholder: string) => {
  return placeholder === WEBSITE_PAGE_URL_PLACEHOLDER
}
export const isWebsitePageUrlPlaceholderValue = (value: string) => {
  return isWebsitePageUrlPlaceholder(value.replace(/\d+/g, ' '))
}

export const getWebsitePageContentIdFromPlaceholder = (value: string) => {
  if (!isWebsitePageUrlPlaceholderValue(value)) {
    return null
  }

  const pageContentId = Number(value.match(/\d+/)?.[0])

  return Number.isNaN(pageContentId) ? null : pageContentId
}
